@if (field && !field.multiple) {
	<mat-form-field appearance="outline">
		<mat-label [attr.for]="field?.key">{{ field?.label }}</mat-label>
		<input
			type="text"
			matInput
			[formControlName]="field?.key"
			[matAutocomplete]="auto"
			[placeholder]="'Buscar'"
			(blur)="onBlur()"
		/>
		<mat-autocomplete
			#auto="matAutocomplete"
			[displayWith]="displayFn"
			(optionSelected)="onOptionSelected($event)"
		>
			@for (opt of field?.options; track opt.key) {
				<mat-option
					[value]="opt"
					(mousedown)="$event.preventDefault()"
					[matTooltip]="getTooltip(opt)"
				>
					<p>{{ opt.value }}</p>
				</mat-option>
			}
		</mat-autocomplete>
		@if (controlContainer.control?.get(field?.key)?.hasError('required')) {
			<mat-error>Debe completar el campo.</mat-error>
		}
		@if (controlContainer.control?.get(field?.key)?.hasError('valueExists')) {
			<mat-error>
				{{ field?.rules?.valueExists?.errorMessage }}
			</mat-error>
		}
	</mat-form-field>
}

@if (field && field.multiple) {
	<mat-form-field appearance="outline">
		<mat-label [attr.for]="field?.key">{{ field?.label }}</mat-label>
		<input
			type="text"
			[placeholder]="'Buscar'"
			matInput
			[matAutocomplete]="autoMulti"
			[formControlName]="field?.key"
			(blur)="onBlur()"
		/>
		@if (controlContainer.control?.get(field?.key)?.hasError('required')) {
			<mat-error>Debe completar el campo.</mat-error>
		}
	</mat-form-field>
	<mat-autocomplete
		#autoMulti="matAutocomplete"
		[displayWith]="displayFnMultiple"
	>
		@for (opt of field?.options; track opt) {
			<mat-option [value]="selectedCities">
				<div (click)="optionClicked($event, opt)">
					<mat-checkbox
						[checked]="opt.selected"
						(change)="toggleSelection(opt)"
						(click)="$event.stopPropagation()"
					>
						<p>{{ opt.value }}</p>
					</mat-checkbox>
				</div>
			</mat-option>
		}
	</mat-autocomplete>
	@if (controlContainer.control?.get(field?.key)?.hasError('required')) {
		<mat-error>Debe completar el campo.</mat-error>
	}
}
